import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BasicCodepen icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BasicCodepen } from '@sravni/design-system-icons'
 *
 * <BasicCodepen />
 * ```
 */
var BasicCodepen = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BasicCodepen", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#BasicCodepen__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "m10.736 1 9 5.85v6.3l-9 5.85-9-5.85v-6.3l9-5.85ZM10.736 19v-6" }),
        React.createElement("path", { d: "m19.736 7-9 6-9-6" }),
        React.createElement("path", { d: "m6.736 10 4-3 4 3M10.736 1v6" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "BasicCodepen__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))); });

export { BasicCodepen };
//# sourceMappingURL=BasicCodepen.js.map
